import {HTMLAttributes} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {isTrue} from '../../../common/shared/utils/isTrue';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';

export function ContentHomeUpperTabItem({
  href,
  isActive,
  hasNewIcon,
  draggable,
  className,
  children,
  ...props
}: {
  href: string;
  hasNewIcon?: boolean;
  isActive?: boolean;
} & HTMLAttributes<HTMLAnchorElement>) {
  return (
    <UrlLink
      url={href}
      draggable={isTrue(draggable)}
      linkClassName={twMerge('z-10', 'shrink-0')}
      className={twMerge(
        'flex cursor-pointer select-none items-center justify-center',
        className
      )}
      {...props}
    >
      <div
        className={twMerge('relative flex h-36px max-w-full px-14pxr pt-6pxr')}
      >
        <Text
          className={twMerge(
            'relative inline-block h-24px whitespace-nowrap text-center',
            isActive
              ? 'font-medium2-bold text-theme-solid-100'
              : 'font-medium2-bold text-theme-solid-40',
            isActive &&
              'before:absolute before:left-0 before:bottom-0 before:h-2pxr before:w-full before:rounded-2pxr before:bg-theme-solid-100 before:content-[""]'
          )}
        >
          {children}
        </Text>
        {hasNewIcon && (
          <Icon
            type={IconType.ContentHomeNewStatic}
            className="absolute top-0 right-0 h-12pxr w-12pxr"
          />
        )}
      </div>
    </UrlLink>
  );
}
